import { FOOTER, NAV } from '../constants/tracking';

/* @type - footer or nav type
 * @element - an html element
 * helper function for finding the correct tracking element for a footer or nav element
 */
const getFooterOrNavExtras = (type: string, element: HTMLElement) => {
    const ret = {};
    if (type === FOOTER) {
        const parentWrapper = element.closest('.vds-footer--list-wrapper');
        const parentList = element.closest('.vds-footer-list');
        const socialList = element.closest('.vds-footer-socials');
        const closestUL = element.closest('ul');
        const closestLI = element.closest('li');
        const children = closestUL?.childNodes;
        const isSocials = socialList ? true : false;
        let row, col;

        if (children) {
            row = Array.prototype.indexOf.call(children, closestLI);
            if (row > -1) {
                // String-cast: numeric 0 is dropped by Adobe Launch's truthy guard,
                // and the data-layer schema types these as strings.
                Object.assign(ret, { posRowNum: String(row) });
            }
        }

        if (parentWrapper) {
            if (isSocials && socialList && socialList?.childNodes) {
                col = Array.prototype.indexOf.call(parentWrapper?.childNodes, socialList);
            } else if (parentList && parentWrapper?.childNodes) {
                col = Array.prototype.indexOf.call(parentWrapper?.childNodes, parentList);
            }

            if (col !== undefined && col > -1) {
                Object.assign(ret, { posColNum: String(col) });
            }
        }
    } else if (type === NAV) {
        const classList = element?.classList.value.split(' ') || [];
        const logoClass = classList.filter((elementClass) =>
            elementClass.toLowerCase().includes('main__logo'),
        );
        const mobileLogoClass = classList.filter((elementClass) =>
            elementClass.toLowerCase().includes('vds-nav-menu'),
        );

        if (logoClass && logoClass.length > 0) {
            Object.assign(ret, { posColNum: 0, posRowNum: 0, ctaText: 'logo' });
        }

        if (mobileLogoClass && mobileLogoClass.length > 0) {
            const expanded = element.getAttribute('aria-expanded');
            Object.assign(ret, {
                ctaText: `mobileNavIcon-${expanded === 'true' ? 'open' : 'closed'}`,
            });
        }
    }
    return ret;
};

export { getFooterOrNavExtras };
